import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { checkAuth } from '../services/authService';

const ProtectedRoute = ({ children }) => {
  const [state, setState] = useState({ checked: false, authenticated: false });

  useEffect(() => {
    checkAuth()
      .then(() => setState({ checked: true, authenticated: true }))
      .catch(() => setState({ checked: true, authenticated: false }));
  }, []);

  if (!state.checked) return null;
  return state.authenticated ? children : <Navigate to="/login" replace />;
};

export default ProtectedRoute;
